import { hbg, ucHbg } from "./http.service";

export const apiGiftbox = {
  /**
     * 获取盲盒数量
     * inviter_rate	string	[0,1]	Y	邀请人返佣比例
     invitee_rate	string	[0,1]	Y	被邀请人返现比例
     second_level_rate	string	[0,1]	Y	二级邀请比例(没有0，有最大为0.05)
     remark	string	[0,255]	N	备注
     defaultCode	int	[2]	N	是否设置为默认邀请码 0 否 1 是
     * */


  getGiftboxCount() {
    return hbg.get("/activity-center/hbg/v1/activity/gift-box/count", {});
  },

  // 获取福利中心配置的任务列表
  getGiftTask(params) {
    return hbg.get("/activity-center/hbg/v1/activity/gift-box/task", {
      params
    });
  },
  // 获取福利中心配置的任务列表
  getGiftboxList(params) {
    return hbg.get("/activity-center/hbg/v1/activity/gift-box/list", {
      params
    });
  },
  // 催一催 m1RemindM2
  getGiftboxRemind(params) {
    return hbg.get("/activity-center/hbg/v1/activity/gift-box/remind", {
      params
    });
  },
  // 邀请人列表详情用
  getNewInviteListInfoDetail(params) {
    return ucHbg.get("/hbg/uc/hbg/open/invite/v2/inviter_award/list_all", {
      params,
    });
  },

  getCashbackAmountList(params) {
    return hbg.get("/pro/v1/cashback/list-group-by-day", {
      params,
    });
  },

  // 用户开盲盒
  giftOpen(data) {
    return hbg.post("/activity-center/hbg/v1/activity/gift-box/open", { data });
  },
  // giftOpen(params) {
  //   return hbg.post("/activity-center/hbg/v1/activity/gift-box/open", { params });
  // },
  //获取用户返佣明细 type	int	是	1返佣  2返现
  queryCommission(params) {
    return ucHbg.get("/pro/v1/inviter/brokerage/queryCommissionByDay", {
      params,
    });
  },
  
};
